export default "__VITE_ASSET__08624806__"